var zIndexes;
(function (zIndexes) {
    zIndexes[zIndexes["navigationDialogOverlay"] = 320] = "navigationDialogOverlay";
    zIndexes[zIndexes["navigationDialog"] = 330] = "navigationDialog";
    zIndexes[zIndexes["navigationPopover"] = 340] = "navigationPopover";
})(zIndexes || (zIndexes = {}));

export { zIndexes };
